import Dialog from './Dialog';
import Text from './Text';
import common from '../common';

export default class ConfirmDialog extends Dialog {
	constructor(w, h) {
		super(w, h, null);

		this.init();
	}

	init() {
		this.body.cancelButton = common.buttonFactory.createButton({
			normal: { textureName: 'btn_black_outline_9slice_out', width: 200, height: 75, left: 35, top: 35, right: 35, bottom: 35 },
			over: { textureName: 'btn_black_outline_9slice_out', width: 200, height: 75, left: 35, top: 35, right: 35, bottom: 35 },
		});

		this.body.cancelButton.label = new Text('gui.general.options.no', { font: '32px', fontWeight: 'bold', align: 'left', tint: 0x0 });
		this.body.cancelButton.label.anchor.set(0.5);
		this.body.cancelButton.animation.addChild(this.body.cancelButton.label);
		this.body.cancelButton.accessibleTitle = this.body.cancelButton.label.text;
		this.body.addChild(this.body.cancelButton);
		this.body.cancelButton.position.set(this.body.width * 0.5 - this.body.cancelButton.width * 0.5 - 10, this.body.height - 120);

		this.body.confirmButton = common.buttonFactory.createButton({
			normal: { textureName: 'btn_blue_fill_large_9slice_out', width: 200, height: 75, left: 35, top: 35, right: 35, bottom: 35 },
			over: { textureName: 'btn_blue_fill_large_9slice_over', width: 200, height: 75, left: 35, top: 35, right: 35, bottom: 35 },
		});

		this.body.confirmButton.label = new Text('gui.general.options.yes', { font: '32px', fontWeight: 'bold', align: 'left', tint: 0xFFFFFF });
		this.body.confirmButton.label.anchor.set(0.5);
		this.body.confirmButton.animation.addChild(this.body.confirmButton.label);
		this.body.confirmButton.accessibleTitle = this.body.confirmButton.label.text;
		this.body.addChild(this.body.confirmButton);
		this.body.confirmButton.position.set(this.body.width * 0.5 + this.body.confirmButton.width * 0.5 + 10, this.body.height - 120);

		P3.utils.performNextTick(() => {
			this.body.confirmButton.y = this._panel.body.text.y + this._panel.body.text.height + 100;
			this.body.cancelButton.y = this._panel.body.text.y + this._panel.body.text.height + 100;

			const height = this.body.confirmButton.y + this.body.confirmButton.height + 25;

			this.resize(height);
		});
	}

	get confirmButton() {
		return this.body.confirmButton;
	}

	get cancelButton() {
		return this.body.cancelButton;
	}
}
